<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/timetable-management/timetable" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>TimeTable & Calendar
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>TimeTable Details
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div>
                    <modal :show.sync="modals.TimeTableModal" modal-classes="modal-dialog-centered modal-md">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <form role="form">
                                        <div class="card">
                                            <h5 class="card-header">Time Table Setup</h5>
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Day</label>
                                                    <select v-model="TimeTableDayIdVal" class="form-control">
                                                        <option value="0">- Select Day -</option>
                                                        <option v-for="item in TimeTableDays" :key="item.timeTableDayId"
                                                            v-bind:value="item.timeTableDayId">
                                                            {{ item.timeTableDay }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Time Slot</label>
                                                    <select v-model="TimeTableTimeSlotIdVal" class="form-control">
                                                        <option value="0">-Select Time Slot</option>
                                                        <option v-for="item in TimeTableTimeSlots"
                                                            :key="item.timeTableTimeSlotId"
                                                            v-bind:value="item.timeTableTimeSlotId">
                                                            {{ item.slotPeriod }} From {{ item.timeFrom }} - To {{
                                                                item.timeEnd
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Subject</label>
                                                    <select v-model="SubjectIdVal" class="form-control">
                                                        <option value="0">-Select Subject</option>
                                                        <option v-for="item in Subjects" :key="item.schoolSubjectId"
                                                            v-bind:value="item.schoolSubjectId">
                                                            {{ item.schSubject }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.TimeTableModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="SubmitData()">Submit
                            </base-button>
                        </template>
                    </modal>
                    <div class="card">
                        <div class="card-body">
                            <div class="justify-content-end form-inline my-3">
                                <div class="justify-content-end form-inline my-3">
                                    <select v-model="RegisteredTermIdVal" class="form-control">
                                        <option value="0">- Select Registered Term -</option>
                                        <option v-for="item in RegisteredTerms" :key="item.registeredTermId"
                                            v-bind:value="item.registeredTermId">
                                            {{ item.schSession }} - {{ item.schTerm }}
                                        </option>
                                    </select>
                                    <select v-model="ClassIdVal" class="form-control" @change="getoption()">
                                        <option value="0">- Select Class -</option>
                                        <option v-for="item in SchoolClasses" :key="item.Id" v-bind:value="item.Id">
                                            {{ item.Sch_Class }}
                                        </option>
                                    </select>
                                    <select v-model="OptionIdVal" class="form-control"
                                        @change="getarm(); GetSchoolSubjects()">
                                        <option value="0">-Select Option -</option>
                                        <option v-for="item in SchoolOptions" :key="item.Id" v-bind:value="item.Id">
                                            {{ item.ClassOption }}
                                        </option>
                                    </select>
                                    <select v-model="SectionIdVal" class="form-control" @change="GetTimeTableDetails()">
                                        <option value="0">- Select Arm - </option>
                                        <option v-for="item in SchoolArms" :key="item.Id" v-bind:value="item.Id">
                                            {{ item.SectionName }}
                                        </option>
                                    </select>
                                    <button v-if="SectionIdVal" type="button" @click.prevent="ViewTimeTableTimeSlot"
                                        class="btn btn-default">
                                        <i class="fa fa-plus"></i> Time Slot
                                    </button>
                                    <button v-if="SectionIdVal" type="button" @click.prevent="ViewTimeTableBreak"
                                        class="btn btn-default">
                                        <i class="fa fa-plus"></i> TimeTable Break
                                    </button>
                                    <button v-if="SectionIdVal" type="button" @click.prevent="OpenTimeTable"
                                        class="btn btn-default">
                                        <i class="fa fa-plus"></i> Time Table Details
                                    </button>
                                </div>
                            </div>
                            <list-skeleton v-if="loading && SectionIdVal" :rows="3" />
                            <div v-else>
                                <div v-if="!TimeTableDetails">
                                    <p class="text-center">No Time Tables Details Found.</p>
                                </div>
                                <div v-else>
                                    <div id="printContainer">
                                        <div v-html="TimeTableDetails"></div>
                                    </div>
                                    <div class="text-center">
                                        <button type="button" @click.prevent="SendTimeTableDetails"
                                            class="btn btn-default">
                                            <i class="fa fa-envelope"></i> Send To All Students
                                        </button>
                                        <button type="button" @click.prevent="printTimeTable"
                                            class="btn btn-default">
                                            <i class="fa fa-print"></i> Print Time Table
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: "TimeTable",
    components: {
        PageSpinner
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            TimeTableIdVal: localStorage.getItem("TimeTableId") || "",
            TimeTableTimeSlotIdVal: 0,
            TimeTableDayIdVal: 0,
            SubjectIdVal: 0,
            TimeTableDays: null,
            TimeTableTimeSlots: null,
            TimeTableDetails: null,
            SchoolArms: null,
            SchoolOptions: null,
            Subjects: null,
            ClassIdVal: 0,
            OptionIdVal: 0,
            SectionIdVal: 0,
            RegisteredTermIdVal: 0,
            SchoolClasses: null,
            RegisteredTerms: null,
            searchval: "",
            onloader: "none",
            loading: true,
            IsModified: false,
            modals: {
                TimeTableModal: false
            }
        };
    },
    methods: {
        OpenTimeTable() {
            this.TimeTableDayIdVal = 0;
            this.SubjectIdVal = 0;
            this.TimeTableTimeSlotIdVal = 0;
            this.modals.TimeTableModal = true;
        },
        SubmitData() {
            let TimeTableId = this.TimeTableIdVal;
            let RegisteredTermId = this.RegisteredTermIdVal;
            let TimeTableDayId = this.TimeTableDayIdVal;
            let SectionId = this.SectionIdVal;
            let SubjectId = this.SubjectIdVal;
            let TimeTableTimeSlotId = this.TimeTableTimeSlotIdVal;
            this.onloader = "flex";
            let userdata = {
                TimeTableId,
                RegisteredTermId,
                TimeTableDayId,
                SectionId,
                SubjectId,
                TimeTableTimeSlotId
            };
            this.$store
                .dispatch("TimeTable/CreateTimeTableDetails", userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.GetTimeTableDetails();
                        this.modals.TimeTableModal = false;
                        this.TimeTableDayIdVal = 0;
                        this.SubjectIdVal = 0;
                        this.TimeTableTimeSlotIdVal = 0;
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetTimeTableDetails() {
            if (this.SectionIdVal) {
                this.onloader = "flex";
                this.loading = true;
                let userData = {};
                let TimeTableId = this.TimeTableIdVal;
                let SectionId = this.SectionIdVal;
                let RegisteredTermId = this.RegisteredTermIdVal;
                userData = {
                    TimeTableId,
                    SectionId,
                    RegisteredTermId
                };
                this.$store
                    .dispatch("TimeTable/GetTimeTableDetailsString", userData)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            this.TimeTableDetails = resp.data;
                        }
                        this.onloader = "none";
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }

        },
        SendTimeTableDetails() {
            if (this.SectionIdVal) {
                this.onloader = "flex";
                this.loading = true;
                let userData = {};
                let TimeTableId = this.TimeTableIdVal;
                let SectionId = this.SectionIdVal;
                let RegisteredTermId = this.RegisteredTermIdVal;
                userData = {
                    TimeTableId,
                    SectionId,
                    RegisteredTermId
                };
                this.$store
                    .dispatch("TimeTable/SendTimeTableDetails", userData)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            this.ShowAlertSuccess(resp.data, '');
                        }
                        this.onloader = "none";
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }

        },
        printTimeTable() {
            const printContents = document.getElementById('printContainer').innerHTML;
            const w = window.open('', '', 'height=600,width=800');
            w.document.write('<html><head><title>TimeTable</title></head><body>');
            w.document.write(printContents);
            w.document.write('</body></html>');
            w.document.close();
            w.print();
        },
        GetPortalRegisteredTerm() {
            let userdata = {
                SearchValue: null,
                PageNumber: 1,
                PageSize: 100
            }
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("PortalSchoolSessionTerm/GetPortalRegisteredTerm", userdata)
                .then((resp) => {
                    this.RegisteredTerms = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetTimeTableDays() {
            this.onloader = "flex";
            this.$store
                .dispatch("TimeTable/GetTimeTableDays")
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTableDays = resp.data;
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, "");
                });
        },
        GetTimeTableTimeSlotsNotForBreak() {
            this.onloader = "flex";
            let TimeTableId = this.TimeTableIdVal;
            this.$store
                .dispatch("TimeTable/GetTimeTableTimeSlotsNotForBreak", TimeTableId)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTableTimeSlots = resp.data;
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    console.log(err);
                });
        },
        getclass() {
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.SchoolClasses = resp;
                })
                .catch((err) => {
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getoption() {
            this.SchoolOptions = null;
            this.SchoolArms = null;
            let ClassId = this.ClassIdVal;
            if (ClassId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getoptionbyclass", ClassId)
                    .then((resp) => {
                        this.SchoolOptions = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getarm() {
            let ClassId = this.ClassIdVal;
            let OptionId = this.OptionIdVal;
            let SchArm = "Search";
            let Id = 1;
            let processop = 'N';
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            this.onloader = "flex";
            let payload = {
                Id,
                ClassId,
                OptionId,
                SchArm,
                processop,
                username,
                accesskey,
            };
            this.$store
                .dispatch("getarmbyoption", payload)
                .then((resp) => {
                    this.SchoolArms = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolSubjects() {
            if (this.OptionIdVal) {
                this.onloader = "flex";
                let OptionId = this.OptionIdVal;
                this.$store
                    .dispatch("PortalSchoolSubject/PortalGetSchoolSubjects", OptionId)
                    .then((resp) => {
                        if (resp.responseCode == "00") {
                            this.Subjects = resp.data;
                        }
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }

        },
        ViewTimeTableTimeSlot() {
            let TimeTableId = this.TimeTableIdVal;
            localStorage.setItem("TimeTableId", TimeTableId);
            this.$router.push("/school/timetable-management/timetable-timeslot");
        },
        ViewTimeTableBreak() {
            let TimeTableId = this.TimeTableIdVal;
            localStorage.setItem("TimeTableId", TimeTableId);
            this.$router.push("/school/timetable-management/timetable-break");
        },
    },
    mounted() {
        this.GetTimeTableDetails();
        this.getclass();
        this.GetPortalRegisteredTerm();
        this.GetTimeTableTimeSlotsNotForBreak();
        this.GetTimeTableDays();
    },
};
</script>
